import { initEtc, setEtc } from '@modules/etc';
import { useDispatch } from '@stores';
import { IStoreEtc } from '@types';
import { useCallback } from 'react';

const useEtcActions = () => {
  const dispatch = useDispatch();

  const onInitEtc = useCallback(() => {
    dispatch(initEtc());
  }, [dispatch]);

  const onSetEtc = useCallback(
    (payload: IStoreEtc) => {
      dispatch(setEtc(payload));
    },
    [dispatch]
  );

  return { onInitEtc, onSetEtc };
};

export default useEtcActions;
